const emailSendConstants = {
  EMAIL_SEND_ITEM_ATTEMPT: "EMAIL_SEND_ITEM_ATTEMPT",
  EMAIL_SEND_ITEM_SUCCESS: "EMAIL_SEND_ITEM_SUCCESS",
  EMAIL_SEND_ITEM_FAILURE: "EMAIL_SEND_ITEM_FAILURE",
  SEND_MESSAGE_LENGTH: 200,
  SHARETYPE_PRODUCT: "product",
  SHARETYPE_WISHLIST: "wishlist",
  SEND_PDP: "SEND_PDP",
  SEND_WISHLIST: "SEND_WISHLIST",
  EMAIL_SEND_RESET_STATE: "EMAIL_SEND_RESET_STATE",
  EMAIL_SEND_WRAPPER_WISHLIST: "email-send-wrapper_wishlist",
  EMAIL_SEND_WRAPPER_PRODUCT: "email-send-wrapper_product",
}

export default emailSendConstants
